import script from "./MiniChat.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniChat.vue?vue&type=script&setup=true&lang=js"

import "./MiniChat.vue?vue&type=style&index=0&id=2eac035e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eac035e"]])

export default __exports__